import { ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar.js";
import { Grid } from "../core/components/grid.js";
import { EditMachine } from "./editMachine.js";
import { Helper } from "../core/util/helper.js";
import { HTTPService, JsonResultClass } from "../core/util/httpManager.js";
import { General } from "../../siteManagement/general.js";
import { SheetEventType } from "../../siteManagement/sheet.js";
import { NotificationHelper } from "../core/util/notificationHelper.js";
import { DialogHelper } from "../core/util/dialogHelper.js";
import { ProjectAppProps } from "./project.js";
import { CommonAppProps, Metadata } from "../core/components/commonApp.js";
import React from "react";


export default class Machines extends React.Component<ProjectAppMachinesProps, any>{
    private _gridData = [];
    private _gridOptions = {};
    private _translations = {};
    private _dataUrl: string;
    private _enabled: boolean;

    constructor(props) {
        super(props);
        this._enabled = true;
        this._dataUrl = "ProjectMachine/GetGridData?id=" + props.entity.Projnr;
        this._gridOptions = props.context.machinesGrid;
        this._translations = props.translations;
    }

    private _getGridData() {
        HTTPService.get(this._dataUrl)
            .then(result => {
                this._gridData = result.Data;
                this.setState({});
            });
    }


    private _add = () => {
        const url = "DynamicSearch/Window/Machine/?multi=true&displayPattern=[[maschnr]] [[maschbezeichnung]]&adrnr=" + this.props.entity.Adrnr + "&status=0";
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, null, { disableTabTitle: true });
        sheet.setTitle(this._translations["Maschine.Maschinensuche"]);
        sheet.bind(SheetEventType.ItemsSelected, async (ev) => {
            const data = ev.data;
            if (data.length > 0) {
                let machines: string[] = data.map(d => d.maschnr);
                // let additionalParams = [{Key: "PROJNR", Value: this.props.entity.Projnr}];
                // let additionalParams = {};
                // additionalParams["PROJNR"] = this.props.entity.Projnr;
                const hasReferences = await HTTPService.post<JsonResultClass<boolean>>('ProjectMachine/HasMachineReferences', {machineNrs: machines, addParams: null});
                if(hasReferences.Code == 0) {
                    let includeReferences = false;
                    if(hasReferences.Data) {
                        includeReferences = await DialogHelper.confirm(this._translations["WebSMS.Project.AddAssignedMachines"], null, Helper.getTranslation("Server.No"), Helper.getTranslation("Server.Yes"));
                    }
                    HTTPService.post<JsonResultClass>('ProjectMachine/AddMachines', {
                        id: this.props.entity.Projnr,
                        machines: data,
                        includeReferences: includeReferences
                    })
                        .then(result => {
                            if (result.Code === 0) {
                                this._getGridData();
                            } else {
                                NotificationHelper.showSuccessMessage(result.Message);
                            }
                        });
                }else{
                    NotificationHelper.showErrorMessage(hasReferences.Message);
                }
            }
        });
    }

    private _edit = (dataItem: any) => {
        const sheet = General.Sheet.Manager.createSheet();
        sheet.setTitle(this._translations["WebSMS.Project.Machine"]);

        sheet.bind(SheetEventType.SavedSuccessfully, (target) => {
            this._getGridData();
        });

        HTTPService.chainBatch
            .add<JsonResultClass>('ProjectMachine/Init?projNr=' + encodeURIComponent(this.props.entity.Projnr) + '&maschNr=' + encodeURIComponent(dataItem.Maschnr))
            .add<Metadata>(Helper.getMetaData("projectMachine"))
            .promise()
            .then(result => {
                sheet.show(() => {
                    const machine = result[0].Data;
                    const metaData = result[1];

                    const machineEditProps: CommonAppProps = {
                        entity: machine,
                        metadata: metaData,
                        context: { key1: "", keyVal1: null, contextType: "projectMachine" },
                        dataSources: {},
                        isWindow: true,
                        handleMenuSelect: null,
                        enableMenuItem: null,
                        handleCreateValidator: null,
                        handleFieldChange: null,
                        handleDataLoaded: null,
                        onChange: null
                    }

                    sheet.mountContent(EditMachine, machineEditProps);
                });
            });
    }

    private _remove = async (dataItem) => {
        if (await DialogHelper.confirm(this._translations["Standard.Msg.Loeschen"])) {
            // let additionalParams = [{key: "PROJNR", value: this.props.entity.Projnr}];
            let additionalParams = {};
            additionalParams["PROJNR"] = this.props.entity.Projnr;
            const hasReferences = await HTTPService.post<JsonResultClass<boolean>>('ProjectMachine/HasMachineReferences', {machineNrs: [dataItem.Maschnr], type: 1, addParams: additionalParams});
            if(hasReferences.Code == 0){
                let includeReferences = false;
                if(hasReferences.Data){
                    includeReferences = await DialogHelper.confirm(Helper.getTranslation("WebSMS.Project.DeleteAssignedMachines"), null, Helper.getTranslation("Server.No"), Helper.getTranslation("Server.Yes"));
                }
                HTTPService.post('ProjectMachine/DeleteMachine', { Projnr: this.props.entity.Projnr, Maschnr: dataItem.Maschnr, includeReferences: includeReferences })
                    .then(result => {
                        this._getGridData();
                    });
            }else{
                NotificationHelper.showErrorMessage(hasReferences.Message);
            }
        }
    }

    handleClickStandardButton = (type: ToolBarStandardButtonType, dataItem: any) => {
        if (type === ToolBarStandardButtonType.NEW) {
            this._add();
        } else if (type === ToolBarStandardButtonType.EDIT) {
            this._edit(dataItem);
        } else if (type == ToolBarStandardButtonType.DELETE) {
            this._remove(dataItem);
        }
    }

    componentDidMount() {
        this._checkEditability();
        this._setEvents();
        this._getGridData();
    }

    private _setEvents = () => {
        let sheet = General.Sheet.Manager.getTopMostSheet();
        sheet.bind(SheetEventType.Custom, (cus) => {
            if (cus.command === "projectStatusChanged") {
                this._enabled = cus.value;
                this.setState({});
            }
        });
    }

    private _checkEditability = () => {
        if (this.props.context.contextType === "project") {
            this._enabled = this.props.entity.ProjectStatus.Editing;
            this.setState({});
        }
    }

    render() {
        const standardButtons: Array<ToolBarStandardButton> = [];
        standardButtons.push({ type: ToolBarStandardButtonType.NEW, caption: this._translations["Standard.Neu"], enabled: this.props.entity.RecordRight.CanWrite && this._enabled });
        standardButtons.push({ type: ToolBarStandardButtonType.EDIT, caption: this._translations["Standard.Editieren"], enabled: this.props.entity.RecordRight.CanWrite && this._enabled });
        standardButtons.push({ type: ToolBarStandardButtonType.DELETE, caption: this._translations["Standard.Loeschen"], enabled: this.props.entity.RecordRight.CanWrite && this._enabled });

        const content = <Grid data={this._gridData} options={this._gridOptions} id="projectMachines"
            standardButtons={standardButtons} onClickStandardButton={this.handleClickStandardButton} />

        return (content);
    }
}

interface ProjectAppMachinesProps extends ProjectAppProps {
    translations: Array<string>;
}